const WPC_BASE = 'https://www.wpc.ncep.noaa.gov';

/** WPC pages embed small JPG thumbnails; full-size maps are linked as GIFs. */
export function wpcQpfFullSizeImageUrl(urlOrPath: string, baseUrl = WPC_BASE): string {
  const trimmed = urlOrPath.trim();
  let path = trimmed;
  let search = '';

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const u = new URL(trimmed);
      path = u.pathname;
      search = u.search;
    } catch {
      return trimmed;
    }
  } else if (trimmed.includes('?')) {
    const q = trimmed.indexOf('?');
    path = trimmed.slice(0, q);
    search = trimmed.slice(q);
  }

  const upgraded = path
    .replace(/\/qpf\/p120i_sm\.jpe?g$/i, '/qpf/p120i.gif')
    .replace(/\/qpf\/p168i_sm\.jpe?g$/i, '/qpf/p168i.gif');

  const finalPath = upgraded.startsWith('/') ? upgraded : `/${upgraded.replace(/^\//, '')}`;
  const origin = baseUrl.replace(/\/$/, '');
  return `${origin}${finalPath}${search}`;
}
